<template>
  <div>
    <div class="breadcrumb-area pos-relative w-100">
      <h2 class="title_h">Danh sách MC ưu đãi SME</h2>
    </div>
    <div class="card p-10 pt-15">
      <div class="card-header m-b-10">
        <form class="box-search" @submit.prevent="submitForm">
          <div class="form-group">
            <input
              type="text"
              v-model.trim="filters.keyword"
              class="form-control f12 hc-37 text-search"
              placeholder="Từ khóa"
            />
          </div>
          <div class="form-group">
            <Select2
              v-model="filters.handlerId"
              :options="optionsTypeSale"
              placeholder="Phụ trách"
            />
          </div>
          <div class="form-group">
            <Select2
              v-model="filters.promotionType"
              :options="dataConfigPromotionType"
              placeholder="Loại ưu đãi"
            />
          </div>
          <div class="form-group">
            <Select2 v-model="filters.groupMc" :options="dataConfigGroupMc" placeholder="Nhóm MC" />
          </div>
          <div class="form-group">
            <Select2
              v-model="filters.registerPromotion"
              :options="listPromotionStatus"
              placeholder="Trạng thái ĐK ưu đãi"
            />
          </div>
          <div class="form-group">
            <Select2
              v-model="filters.hasTransactionAfterPromotion"
              :options="listHasTransaction"
              placeholder="Có GD sau ngày ưu đãi"
            />
          </div>
          <div class="form-group">
            <Select2
              v-model="filters.hasAdvise"
              :options="listHasAdvise"
              placeholder="TT tư vấn ưu đãi"
            />
          </div>
          <div class="form-group">
            <Select2
              v-model="filters.hasCare"
              :options="listHasCare"
              placeholder="TT CS inactive"
            />
          </div>
          <div class="form-group">
            <Select2
              v-model="filters.businessRegion"
              :options="dataConfigRegion"
              placeholder="Vùng KD"
            />
          </div>
          <div class="form-group">
            <Select2
              v-model="filters.saleId"
              :options="optionsTypeSale"
              placeholder="NV CS chính"
            />
          </div>
          <div class="form-group form-group-action">
            <button
              type="submit"
              class="btn btn-primary hc-37 mr-2 pt-2"
              data-toggle="tooltip"
              data-placement="top"
              title="Lọc"
            >
              <i class="bx bx-filter-alt"></i>
              <span>&nbsp;</span>Lọc
            </button>

            <button
              type="button"
              @click="clearSearch"
              class="btn btn-outline-light hc-37 mr-2 pt-2"
              data-toggle="tooltip"
              data-placement="top"
              title="Bỏ lọc"
            >
              <i class="bx bx-filter-alt"></i>
              <span>&nbsp;</span>Bỏ lọc
            </button>
          </div>
        </form>
      </div>
      <div class="card-body">
        <div class="tab-content">
          <div class="p-10">
            <div class="d-flex flex-row">
              <div class="box-header">
                Tồng:
                <strong class="text-primary">&nbsp;{{ pagination.total }}</strong>
              </div>
            </div>
            <b-table
              hover
              sticky-header
              head-variant="light"
              responsive
              :items="dataTable"
              :fields="fields"
              :fixed="true"
              :bordered="true"
              :busy.sync="isLoading"
            >
              <template #table-busy>
                <div class="text-center my-2">
                  <b-spinner class="align-middle" />
                </div>
              </template>
              <template #empty>
                <div class="text-center text-info my-2">Không có dữ liệu</div>
              </template>

              <template #cell(owner)="{ item }">
                <div>
                  <b-link :href="`/list-mc/${item.customerId}`" target="_blank">
                    {{ item.merchantName || '' }}
                  </b-link>
                </div>
              </template>

              <template #cell(staff)="{ item }">
                <p>{{ item.handlerName }}</p>
                <p>{{ item.handlerEmail }}</p>
              </template>

              <template #cell(promotionType)="{ item }">
                <p>{{ item.promotionTypeName }}</p>
              </template>

              <template #cell(group)="{ item }">
                <p style="font-weight: bold">{{ item.groupMcName }}</p>
                <p>{{ item.taskName }}</p>
              </template>

              <template #cell(status)="{ item }">
                <div class="text-center">
                  <span :class="`badge ${getRegisterPromotionClass(item.registerPromotion)}`">
                    {{ item.registerPromotion ? 'Đã đăng ký' : 'Chưa đăng ký' }}
                  </span>
                </div>
              </template>
              <template #cell(has_gd)="{ item }">
                <div class="text-center">
                  <span
                    :class="`badge ${getHasTransactionClass(item.hasTransactionAfterPromotion)}`"
                  >
                    {{ item.hasTransactionAfterPromotion ? 'Có' : 'Không' }}
                  </span>
                </div>
              </template>

              <template #cell(gd_date)="{ item }">
                <p>{{ item.dateTransaction | formatDate('DD/MM/YYYY') }}</p>
              </template>

              <template #cell(totalTransactionAmount)="{ item }">
                <div
                  class="text-center"
                  v-if="item.totalTransactionAmount && totalTransactionAmount !== 0"
                >
                  {{ item.totalTransactionAmount?.toLocaleString('vi-VN') || '' }}
                </div>
              </template>

              <template #cell(tvud)="{ item }">
                <div class="text-center">
                  <span :class="`badge ${getAdviseClass(item.hasAdvise)}`">
                    {{ item.hasAdvise ? 'Đã tư vấn' : 'Chưa tư vấn' }}
                  </span>
                </div>
              </template>

              <template #cell(cs_inactive)="{ item }">
                <div class="text-center">
                  <span :class="`badge ${getCareClass(item.hasCare)}`">
                    {{ item.hasCare ? 'Đã CS' : 'Chưa CS' }}
                  </span>
                </div>
              </template>

              <template #cell(business_region)="{ item }">
                <p>{{ item.businessRegionName }}</p>
              </template>

              <template #cell(actions)="{ item }">
                <b-dropdown class="text-center" variant="outline-light">
                  <b-dropdown-item
                    :href="`/customer-support/account/${item.merchantAccountId}`"
                    target="_blank"
                  >
                    Chi tiết
                  </b-dropdown-item>

                  <b-dropdown-item
                    v-if="
                      dataPermission && dataPermission.includes('CNPS_DFS_MC_SME_CHANGE_HANDLER')
                    "
                    @click="comfirm(item)"
                  >
                    Chuyển đổi người phụ trách
                  </b-dropdown-item>
                </b-dropdown>
              </template>
            </b-table>
            <div class="d-flex justify-content-end">
              <b-pagination
                v-model="pagination.page"
                :total-rows="pagination.total"
                :per-page="pagination.limit"
                @change="onChangePage"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import { showMess } from '../../../../config/utils'
  import { SearchMCSME } from '../../../../services/customer-support/account'
  import Config from '@/thirdParty/config'
  import { StaffService } from '@/services/staff.service'
  import { mapGetters } from 'vuex'

  export default {
    data() {
      return {
        Config,
        filters: {},
        dataUser: JSON.parse(localStorage.getItem('userData')),
        optionsTypeSale: [],
        listPromotionStatus: [
          { id: true, text: 'Đã đăng ký', bgColor: 'badge-success' },
          { id: false, text: 'Chưa đăng ký', bgColor: 'badge-danger' },
        ],
        listHasTransaction: [
          { id: true, text: 'Có', bgColor: 'badge-success' },
          { id: false, text: 'Không', bgColor: 'badge-danger' },
        ],
        listHasAdvise: [
          { id: true, text: 'Đã tư vấn ưu đãi', bgColor: 'badge-success' },
          { id: false, text: 'Chưa tư vấn ưu đãi', bgColor: 'badge-danger' },
        ],
        listHasCare: [
          { id: true, text: 'Đã chăm sóc inactive', bgColor: 'badge-success' },
          { id: false, text: 'Chưa chăm sóc inactive', bgColor: 'badge-danger' },
        ],
        dataConfigGroupMc: [
          { id: 'Q1', text: 'Quý 1' },
          { id: 'Q2', text: 'Quý 2' },
          { id: 'Q3', text: 'Quý 3' },
          { id: 'Q4', text: 'Quý 4' },
        ],
        dataConfigPromotionType: [
          { id: 'VM', text: 'Visa + Master' },
          { id: 'V', text: 'Visa' },
          { id: 'M', text: 'Master' },
        ],
        dataConfigRegion: [],
        // // ownerSettings: {},
        // mcOwnerOptions: [],

        isLoading: true,
        fields: [
          { key: 'owner', label: 'Tên MC', sortable: false },
          { key: 'staff', label: 'Phụ trách', sortable: false },
          { key: 'promotionType', label: 'Loại ưu đãi', sortable: false },
          { key: 'group', label: 'Nhóm MC', sortable: false },
          {
            key: 'totalTransactionAmount',
            label: 'Giao dịch thẻ',
            sortable: false,
          },
          { key: 'gd_date', label: 'Ngày GD cuối', sortable: false },
          { key: 'has_gd', label: 'Có GD sau ưu đãi', sortable: false },
          { key: 'status', label: 'Trạng thái ĐK ưu đãi', sortable: false },
          { key: 'tvud', label: 'TT tư vấn ưu đãi', sortable: false },
          { key: 'cs_inactive', label: 'TT CS inactive', sortable: false },
          // { key: 'business_region', label: 'Vùng KD', sortable: false },
          { key: 'actions', label: 'Hành động', sortable: false },
        ],
        pagination: {
          page: 1,
          limit: 20,
        },
        dataTable: [],
      }
    },
    async created() {
      this.fetchData()
      this.getListStaffBySuperior()
      this.getRegions()
    },
    computed: {
      ...mapGetters({
        dataPermission: 'role/dataPermission',
      }),
    },
    methods: {
      comfirm(item) {
        console.log('item', item)
        this.$bvModal
          .msgBoxConfirm('Bạn có chắc chắn muốn đổi người phục trách?', {
            title: 'Xác nhận đổi?',
            okTitle: 'Xác nhận',
            cancelTitle: 'Huỷ',
          })
          .then(async value => {
            if (value) {
              this.showLoading = true
              try {
                const res = await StaffService.changeOfPersonIncharge({
                  id: item.id,
                  handlerId: item.handlerId,
                })

                if (res.code === 1000) {
                  showMess(
                    this,
                    'Success',
                    'Đổi người phục trách thành công',
                    'success',
                    'b-toaster-top-right',
                    5 * 60 * 60
                  )

                  this.fetchData()
                } else {
                  showMess(this, 'Error', res.message, 'danger', 'b-toaster-top-right', 5 * 60 * 60)
                }
              } catch (error) {
                showMess(
                  this,
                  'Error',
                  error.response?.data?.message || error.response?.message || error.message,
                  'danger',
                  'b-toaster-top-right',
                  5 * 60 * 60
                )
              } finally {
                this.showLoading = false
              }
            }
          })
          .catch(() => {})
      },
      filterInvalidData(data) {
        if (!data || typeof data !== 'object') {
          return {}
        }

        const result = { ...data }
        let hasInvalidValues = false

        for (const key in result) {
          const value = result[key]

          if (value === null || value === undefined || value === '0' || value === '') {
            delete result[key]
            hasInvalidValues = true
          }
        }
        return hasInvalidValues ? result : data
      },
      submitForm() {
        this.pagination.page = 1
        this.fetchData()
      },
      clearSearch() {
        this.filters = {}
        this.fetchData()
      },
      async getRegions() {
        const data = await StaffService.getRegions()
        if (data.data.length > 0) {
          this.dataConfigRegion = data.data.map(e => {
            return {
              id: e.code,
              text: e.name,
            }
          })
          this.dataConfigRegion.unshift({ id: '0', text: 'Tất cả' })
        }
      },
      async getListStaffBySuperior() {
        try {
          const data = await StaffService.getStaffByIdSuperior({
            userId: this.dataUser.userId || '',
          })
          if (data.data.length > 0) {
            this.optionsTypeSale = data.data.map(e => {
              return {
                id: e.userId,
                text: `${e.name} - ${e.userName}`,
              }
            })
            this.optionsTypeSale.unshift({ id: '0', text: 'Tất cả' })
          }
        } catch (error) {
          console.log(error)
        }
      },
      async fetchData() {
        try {
          this.isLoading = true
          const payload = this.filterInvalidData(this.filters)

          const res = await SearchMCSME({
            ...payload,
            page: this.pagination.page,
            limit: this.pagination.limit,
          })
          if (res.code === 1000) {
            this.dataTable = res.data.list || []
            this.pagination.total = res.data.count ?? 0
          }
        } catch (error) {
          showMess(
            this,
            'Error',
            error.response?.data?.message || error.response?.message || error.message,
            'danger',
            'b-toaster-top-right',
            5 * 60 * 60
          )
        } finally {
          this.isLoading = false
        }
      },
      onChangePage(pageIndex) {
        this.pagination.page = pageIndex
        this.fetchData()
      },
      getRegisterPromotionClass(status) {
        return status ? 'badge-success' : 'badge-danger'
      },
      getHasTransactionClass(hasTransaction) {
        return hasTransaction ? 'badge-success' : 'badge-danger'
      },
      getAdviseClass(hasAdvise) {
        return hasAdvise ? 'badge-success' : 'badge-danger'
      },
      getCareClass(hasCare) {
        return hasCare ? 'badge-success' : 'badge-danger'
      },
    },
  }
</script>
<style scoped></style>
